import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '@core/types';

import { TranslateDirective } from '@ngx-translate/core';
import { FeatherIconDirective } from '../../../../directives/core-feather-icons/core-feather-icons';

@Component({
    selector: '[core-menu-vertical-section]',
    templateUrl: './section.html',
    imports: [TranslateDirective, FeatherIconDirective]
})
export class CoreMenuVerticalSectionComponent {
  @Input()
  item: CoreMenuItem;
}
